import * as S from "./InquirySideMenu.style";
import { useRecoilValue } from "recoil";
import { loginTypeState } from "@/common/states/user";
import { InquirySideMenus } from "@/data/menus";
import { InquirySideMenuList } from "@/components/molecules/InquirySideMenuList";

export const InquirySideMenu = () => {
  const loginType = useRecoilValue(loginTypeState);

  return (
    <S.InquirySideMenu>
      <InquirySideMenuList data={InquirySideMenus} loginType={loginType} />
    </S.InquirySideMenu>
  );
};
